import { gql } from "@apollo/client";

export const CREATE_ACTIVITY_FROM_EMPTY = gql`
  mutation createActivityFromEmptyActivity(
    $model: InsertEmptyActivityModelInput
  ) {
    createActivityFromEmptyActivity(model: $model) {
      activity {
        activityId
        guid
        planDateTime
        updateVersion
        activityStatus {
          activityStatusId
          displayName
          guid
          activityStatusWorkflowToActivityStatusesWf {
            toActivityStatusId
            workflowId
            fromActivityStatus {
              activityStatusId
            }
          }
          activityStatusWorkflowFromActivityStatuses {
            fromActivityStatusId
          }
          activityStatusWorkflowToActivityStatuses {
            displayName
            guid
            activityStatusWorkflowFromActivityStatuses {
              toActivityStatusId
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_ACTIVITY_STATEMENT = gql`
  mutation updateActivityStatement($model: UpdateActivityStatementModelInput) {
    updateActivityStatement(model: $model) {
      activityStatement {
        value
      }
    }
  }
`;

export const UPDATE_ACTIVITY_FROM_EMPTY = gql`
  mutation updateActivityFromEmptyActivity(
    $model: InsertEmptyActivityModelInput
  ) {
    updateActivityFromEmptyActivity(model: $model) {
      activity {
        activityId
      }
    }
  }
`;

export const UPDATE_ACTIVITY_STATUS = gql`
  mutation updateActivityStatus($model: UpdateActivityStatusModelInput!) {
    updateActivityStatus(model: $model) {
      activity {
        activityId
        guid
      }
    }
  }
`;

export const REMOVE_ACTIVITY_DOCUMENT = gql`
  mutation deleteActivityDocument($model: RemoveActivityDocumentModelInput) {
    deleteActivityDocument(model: $model) {
      response
    }
  }
`;
